import { useEffect } from 'react';
import { getAnalyticsAnonymousId } from 'utils/utilities';
import { getAppByRoute } from 'utils/route-utils';
import { setContext, setUser } from '@sentry/react';

interface Props {
  loggedInUser: {
    id: string;
  };
  pathname: string;
}

export const useSentryInitialization = ({ loggedInUser, pathname }: Props) => {
  useEffect(() => {
    setContext('page', {
      currentApp: getAppByRoute(pathname),
    });
    setUser({
      atlassianAccountId: loggedInUser.id,
      analyticsAnonymousId: getAnalyticsAnonymousId(),
    });
  }, [loggedInUser.id, pathname]);
};
